const Style = {
    hero: 'relative overflow-hidden pb-16 pt-20 md:pb-24 md:pt-28',

    glow: `pointer-events-none absolute -top-44 left-1/2 h-[420px] w-[900px] -translate-x-1/2 blur-[20px]
    bg-[radial-gradient(60%_60%_at_40%_50%,rgba(129,140,248,0.28),transparent_70%),radial-gradient(50%_50%_at_70%_40%,rgba(99,102,241,0.16),transparent_70%)]`,

    inner: 'relative mx-auto max-w-6xl px-6 text-center',
    title: 'mb-5 mt-0 text-4xl font-bold leading-[1.1] tracking-[-0.025em] text-text-primary md:text-5xl',
    lede: 'mx-auto mb-8 max-w-[660px] text-lg leading-relaxed text-text-secondary',
    actions: 'mb-14 flex flex-wrap justify-center gap-3',

    frame: 'overflow-hidden rounded-2xl border border-border bg-surface text-left shadow-lg',
    chrome: 'flex h-[38px] items-center gap-1.5 border-b border-border px-3.5',
    dot: 'h-2.5 w-2.5 rounded-full',
    /* No fixed height: the capture is 1863x983, and the width/height attrs on
       the <img> reserve that ratio, so it scales without cropping or CLS.
       block kills the inline-baseline gap under it inside the frame. */
    screen: 'block w-full h-auto',
};

export default Style;
